// src/PrivacyPolicy.js
import React from "react";
import { Container, Typography } from "@mui/material";

function PrivacyPolicy() {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Gizlilik Politikası
      </Typography>
      <Typography variant="body1" paragraph>
        Toruko olarak kullanıcılarımızın gizliliğine önem veriyoruz.
        Platformumuzu kullanırken sağladığınız hiçbir kişisel bilgi üçüncü
        şahıslarla paylaşılmamaktadır. Toruko'de izleme deneyiminizi
        kişiselleştirecek bazı verileri yalnızca analiz ve öneri geliştirme
        amacıyla topluyoruz.
      </Typography>
      <Typography variant="body1" paragraph>
        Topladığımız veriler, hiçbir kişisel bilgi içermeyen anonim verilerdir
        ve yalnızca uygulama içi gelişim amacıyla kullanılmaktadır.
      </Typography>
      <Typography variant="body1">
        Herhangi bir sorunuz veya gizlilikle ilgili endişeniz varsa, bize{" "}
        <a href="mailto:support@korsananime.com">support@korsananime.com</a>{" "}
        adresinden ulaşabilirsiniz.
      </Typography>
    </Container>
  );
}

export default PrivacyPolicy;
